/* @flow */
import React, { Component } from 'react';
import { type FormProps } from 'redux-form';
import type { ContextRouter } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';

import enhancer from '../../enhancer';
import Well from '../../components/Well';

import TutoringCompanyForm from './components/TutoringCompanyForm';

import CreateTutoringCompanyMutation from './mutations/CreateTutoringCompanyMutation';

type Props = ContextRouter & FormProps;

type State = {
  error: ?Error,
};

const styles = {
  toolbarButton: {
    margin: 5,
  },
};

class CreateTutoringCompany extends Component<Props, State> {
  state = {
    error: null,
  };

  handleSave = async ({ studentCount, ...values }) => {
    const { history } = this.props;

    try {
      const { createTutoringCompany } = await CreateTutoringCompanyMutation({
        input: values,
      });
      history.push(
        `/admin/tutoring-company/${createTutoringCompany.tutoringCompany.id}`
      );
    } catch (error) {
      alert(error.message);
      this.setState({ error });
    }
  };

  render() {
    const { submitting, invalid, handleSubmit } = this.props;

    const { error } = this.state;

    return (
      <Well>
        <h3>Create Tutoring Company</h3>
        <TutoringCompanyForm />

        {error && <div>{error.message}</div>}

        {submitting && <LinearProgress mode="indeterminate" />}

        <div>
          <RaisedButton
            disabled={submitting || invalid}
            style={styles.toolbarButton}
            onClick={handleSubmit(this.handleSave)}
            label="Save"
            primary
          />
        </div>
      </Well>
    );
  }
}

export default enhancer(CreateTutoringCompany, {
  form: {
    form: 'createTutoringCompanyForm',
  },
});



// WEBPACK FOOTER //
// ./src/modules/admin/company/CreateTutoringCompany.js